/* eslint-disable no-nested-ternary */
import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { MetricCardListProps } from './types';
import "@/pages/dashboard/assets/scss/page/RealtimeUsers/components/tableLine.scss";
import './index.scss';
import { EXPLAIN_TITLE_KEYS_MAP } from '../MetricCardItem/_costant';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { Icon } from "tea-component";
import cx from 'classnames';
import { formatPercentNum, getIsErrorValue } from '@/pages/dashboard/utils/utils';
import { getImg } from '@home/_config/getImgs';
import { getMediaChannelIcon, mediaChannelMap } from '@/pages/home/_config/mediaChannal';
import Default from '@/pages/home/assets/svg/dashboard/default.svg';

const MetricCardList = (props: MetricCardListProps) => {
  const { list, time, registerDate, isChange = false, showDodSdlw = true, showTotal, dataBy } = props;
  const timeType = 'Day';
  const { formatMessage } = useIntl();
  const getIconImg = (iconName: string) => {
    let img = '';
    try {
      if (dataBy === 'country') {
        img = getCountryFlag(iconName);
      } else if (dataBy === 'ua_network') {
        const channelIcon = getMediaChannelIcon(iconName);
        img = channelIcon === mediaChannelMap._default ? Default : channelIcon;
      } else {
        img = getImg(iconName);
      }
    } catch (e) {
      img = getCountryFlag('default');
    }
    return img;
  };
  const titleKeys = useMemo(() => EXPLAIN_TITLE_KEYS_MAP?.[timeType?.toLowerCase()] || EXPLAIN_TITLE_KEYS_MAP?.day, [timeType]);
  const haveTotal = useMemo(() => {
    if(!showTotal || !list?.length) return false;
    return list?.some(item => item?.nameValue === 'Total');
  }, [list, showTotal]);

  return (
    <>
      <div className='table-line-flex'>
        {registerDate && <div className='table-line-time'>{formatMessage({ id: 'realtime_by_country_register_date' })}: {registerDate}</div>}
        {time && <div className='table-line-time'>{formatMessage({ id: 'realtime_revenue_realtime_revenue_Statistical' })}: {time}</div>}
      </div>
      {
        list && list?.length > 0 &&
        <div className='table-country-line-flex margin-t-20'>
          {
            list?.map((item, index) => (
              <div className='table-line-country' key={index}>
                <div className={`table-line-country-context dbd-realtime-user-count dbd-realtime-user-count-${haveTotal ? index - 1 : index}`}>
                  {item.iconName && getIconImg(item?.iconName) && <img src={getIconImg(item?.iconName)} className='table-line-country-icon' />}
                  <div className='table-line-country-text'>{item.name}</div>
                </div>
                <div className='table-line-country-num'>{item.value}</div>
                {showDodSdlw && (item.name !== 'Others' && item.name !== '其他') &&
                  <div className="overlay-card-body-flex no-pointer">
                    <div className='overlay-card-body-flex-item'>
                      {
                        titleKeys?.map((key: string, index: number) => (
                          (isChange && key === 'change') || (!isChange && key !== 'change') ?
                            <div key={index} className='overlay-card-body-text'>{formatMessage({ id: `overview_${key}` })}</div> : null
                        ))
                      }
                    </div>
                    <div className='overlay-card-body-flex-rightitem'>
                      {
                        titleKeys?.map((key: string, index: string) => {
                          const show_value = item[key];
                          const correctVal = !getIsErrorValue(show_value);
                          const val = !(Number(show_value) < 0);
                          const isZero = Number(show_value) === 0;
                          return (
                            (isChange && key === 'change') || (!isChange && key !== 'change') ?
                              <div key={index} style={{ justifyContent: 'flex-start' }} className={cx({ 'overlay-card-body-textnum': true }, { ["text-green"]: correctVal && val }, { ["text-red"]: correctVal && !val }, { ["text-gray"]: isZero })}>
                                {correctVal ? formatPercentNum(parseFloat(show_value), 1, true) : <span className="data-null"> -</span>}
                                {
                                  correctVal && ((Number(show_value) === 0)
                                    ? <Icon type={'trend-zero'} />
                                    : (Number(show_value) > 0)
                                      ? <SvgIcon className='overlay-card-body-icon' type="green-up-new" />
                                      : <SvgIcon className='overlay-card-body-icon' type="red-down-new" />)
                                }
                              </div> : null
                          );
                        })
                      }
                    </div>
                  </div>
                }
              </div>
            ))
          }
        </div>
      }
    </>
  );
};

export default MetricCardList;